// extracted by mini-css-extract-plugin
export var container = "generator-layout-module--container--YB-cM";
export var content = "generator-layout-module--content--U9qQz";
export var header = "generator-layout-module--header--PwfzR";